import React, { useState, useEffect } from 'react';
import Row from '../Row';
import Col from '../Col';
import UserChatHeader from './UserChatHeader';
import SendMessageBox from './SendMessageBox';
import { useSelector, useDispatch } from 'react-redux';
import DownloadAttachment from './DownloadAttachment';
import { upload } from '../../helpers/upLoadHelper';
import {
  onSendMessage,
  startInboxLoader,
  stopInboxLoader,
} from '../../store/actions/Inbox';
import Button from '../Button';
import Icon from '../Icon';
import { USER_ROLES, PATHS, ErrorMessages } from '../../common/constants';
import './Inbox.scss';
import { useHistory } from 'react-router-dom';
import * as client from '../../services/client';
import Loader from '../Loader';
import { ToastFail } from '../../helpers/validationHelper';

import { sendEmailNotification } from '../../store/actions/Messages';
import { convertTime } from '../../helpers/time';

const InboxMessageChat = ({ selectedItem, onCloseItem, searchString }) => {
  const chatMessagesList = useSelector(
    (state) => state.inbox?.chatMessagesList || []
  );
  const chatUserInfo = useSelector(
    (state) => state.inbox?.chatUserInformation || {}
  );
  const user = useSelector((state) => state.auth?.user || {});

  const [message, setMessage] = useState('');
  const [attachments, setAttachments] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const theme = localStorage.getItem('theme');

  let chatId = selectedItem.ticketId;
  chatId = chatId?.replace(/\s/g, '') || '';
  const roleName = user.roles[0].role.name;
  const tabSelections = useSelector((state) => state.tabSelections);
  const { allowedTabList } = tabSelections;
  const [allowVideoChat, setAllowVideoChat] = useState(true);

  useEffect(() => {
    const videoChat = allowedTabList.filter(
      (item) => item.name === 'Video Chat'
    )[0];
    if (videoChat !== undefined) {
      setAllowVideoChat(true);
    } else {
      setAllowVideoChat(false);
    }
    clearState();
    scrollToBottom();
  }, [selectedItem, chatMessagesList]);

  const scrollToBottom = () => {
    let scroll_to_bottom = document.getElementById(
      selectedItem.referenceType === 'Ticket'
        ? 'scroll-to-bottom1'
        : 'scroll-to-bottom'
    );
    scroll_to_bottom.scrollTop = scroll_to_bottom.scrollHeight;
  };

  const onSetMessage = (value) => {
    setMessage(value);
  };

  const onSetAttachments = (file) => {
    setAttachments(file);
  };

  const sendMessage = async () => {
    const roleName = user.roles[0].role.name;
    let imageUrl = null;
    let sentTo = null;

    if (selectedItem.referenceType === 'Suite') {
      sentTo =
        roleName === USER_ROLES.PROPERTY_DEVELOPER
          ? chatUserInfo.homeOwner && chatUserInfo.homeOwner.userId
            ? chatUserInfo.homeOwner.userId
            : 'No Home Owner'
          : chatUserInfo.propertyManager && chatUserInfo.propertyManager.userId
            ? chatUserInfo.propertyManager.userId
            : null;
    } else {
      sentTo =
        roleName === USER_ROLES.PROPERTY_DEVELOPER
          ? chatUserInfo.reporter?.userId === user.id
            ? chatUserInfo.homeOwner?.userId
            : chatUserInfo.reporter?.userId
          : chatUserInfo.propertyManager?.userId;
    }
    if (
      (selectedItem.referenceType === 'Suite' && sentTo === 'No Home Owner') ||
      sentTo === '00000000-0000-0000-0000-000000000000'
    ) {
      window.confirm(
        'There is no homeowner associated to this suite. Can not send a message now.'
      );
    } else {
      if (attachments && attachments.length > 0) {
        dispatch(startInboxLoader());
        imageUrl = await upload(attachments[0]);
      } else {
        dispatch(stopInboxLoader());
      }
      let fileName = imageUrl ? imageUrl.split('.com/') : '';
      let data = {
        SentBy: user.id,
        SentTo: sentTo ? sentTo : null,
        ReferenceId: selectedItem.referenceId,
        ReferenceType: selectedItem.referenceType,
        Message: message,
        FileName: fileName[1],
        FileURL: imageUrl,
        TicketNumber: selectedItem.ticketNumber,
        ActionUrl: 'app/inbox/' + selectedItem.referenceId,
      };
      const isNew = selectedItem.isNew ? true : false;
      await dispatch(
        onSendMessage(data, isNew, user.id, roleName, searchString)
      );
      clearState();
    }
  };

  const clearState = () => {
    setMessage('');
    setAttachments([]);
  };

  // function to send email notification to join video calling
  const onSendEmailNotification = (data) => {
    const url = {
      pathname: PATHS.VIDEO_CHAT,
      state: {
        chatId: 'channel' + chatId,
        sentByName: data.sentByName,
        sentToName: data.sentToName,
        url: PATHS.INBOX,
      },
    };

    let name = data.sentByName;
    name = name.replace(/\s/g, '');
    let params = {
      SentBy: data.sentTo,
      SentTo: data.sentBy,
      ChannelName: 'channel' + chatId,
      ActionUrl: 'app/videoChat/chatId=channel' + chatId + '/' + name,
      PropertyName: selectedItem.propertyName,
      SuiteName: selectedItem.suiteName,
    };
    dispatch(sendEmailNotification(params, url, history));
  };

  const icon = selectedItem.referenceType === 'Suite' ? 'building' : 'wrench';

  let extraInfo = null;
  if (selectedItem.referenceType === 'Ticket') {
    extraInfo = {
      propertyName: selectedItem?.propertyName || '',
      itemName: selectedItem?.itemName || '',
      issueType: selectedItem?.issueType || '',
    };
  }

  const fetchSuiteById = (selectedItem) => {
    setLoader(true);
    client
      .getPropertySuiteById(selectedItem.referenceId)
      .then((response) => {
        setLoader(false);
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            const route = {
              pathname: PATHS.SUITES_VIEW.replace(
                ':id',
                selectedItem.propertyId + '&' + selectedItem.referenceId
              ),
              state: {
                suite: responsejson,
                property: selectedItem.propertyId,
                navigateTo: PATHS.INBOX,
              },
            };
            history.push(route);
          });
        } else {
          ToastFail(ErrorMessages.error);
          setLoader(false);
        }
      })
      .catch((e) => {
        ToastFail(ErrorMessages.error);
        setLoader(false);
      });
  };

  const onNavigate = () => {
    if (selectedItem.referenceType === 'Ticket') {
      const route = {
        pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(
          ':id',
          selectedItem.referenceId
        ),
        state: { navigateTo: PATHS.INBOX },
      };
      history.push(route);
    } else {
      fetchSuiteById(selectedItem);
    }
  };

  return (
    <div className="messagesArea announcementPadding" id="messagesAreaBg">
      <UserChatHeader
        title={selectedItem?.ticketNumber || ''}
        referenceType={selectedItem?.referenceType || ''}
        description={selectedItem?.description || ''}
        profileIcon={icon}
        address={selectedItem?.address || ''}
        extraInfo={extraInfo}
        backIcon={'mobile_responsive_backbutton'}
        onClickBack={onCloseItem}
        onNavigate={onNavigate}
      />
      {loader && <Loader center={true} />}
      <div
        id={
          selectedItem.referenceType === 'Ticket'
            ? 'scroll-to-bottom1'
            : 'scroll-to-bottom'
        }
      >
        <div className="messagesareaScroll">
          {chatMessagesList &&
            chatMessagesList.length > 0 &&
            chatMessagesList.map((msgObj, i) => {
              return (
                <>
                  <Row key={i}>
                    <Col md={12} xs={12}>
                      <div class="dateDesign">
                        <div class="or or--x" aria-role="presentation">
                          {msgObj.date}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {msgObj.messages.map((msg, i) => {
                    return (
                      <>
                        {msg.sentBy === user.id ? (
                          <>
                            <Row>
                              <Col md={12} xs={12}>
                                <div className="messagesBoxRight">
                                  <div className="messagesBoxContentRight">
                                    <div className="messagesBoxContentRight__texttime">
                                      {' '}
                                      {convertTime(msg.receivedOn, 'LT')}{' '}
                                    </div>
                                    {msg.message && (
                                      <div
                                        className="messagesBoxContentRight__textConent"
                                        style={{ whiteSpace: 'pre-line' }}
                                      >
                                        {msg.message}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {msg.fileURL && (
                              <DownloadAttachment
                                fileURL={msg.fileURL}
                                fileName={msg.fileName ? msg.fileName : ''}
                                mainClass={'rightBox'}
                                subClass={'textRightConent'}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            <Row key={i}>
                              <Col md={12} xs={12}>
                                <div className="messagesBox">
                                  <div className="messagesBoxUsers">
                                    <img
                                      src={
                                        msg.sentByImage
                                          ? msg.sentByImage
                                          : '/assets/avatar.svg'
                                      }
                                      alt=""
                                    />
                                    {allowVideoChat === true &&
                                      roleName !== USER_ROLES.REALTOR && (
                                        <div
                                          className="videoChatStyle"
                                          onClick={() =>
                                            onSendEmailNotification(msg)
                                          }
                                        >
                                          <br />
                                          <img
                                            src={'/assets/icon-chat.png'}
                                            style={{ width: 48, height: 16 }}
                                            alt="avatar"
                                          />
                                        </div>
                                      )}
                                  </div>
                                  <div className="messagesBoxContent">
                                    <div className="messagesBoxContent__texttime">
                                      <span>{msg.sentByName}</span>{' '}
                                      {convertTime(msg.receivedOn, 'LT')}
                                    </div>
                                    {msg.message && (
                                      <div
                                        className="messagesBoxContent__textConent"
                                        style={{ whiteSpace: 'pre-line' }}
                                      >
                                        {msg.message}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {msg.fileURL && (
                              <DownloadAttachment
                                fileURL={msg.fileURL}
                                fileName={msg.fileName ? msg.fileName : ''}
                                mainClass={'leftBox'}
                                subClass={'textLeftConent'}
                              />
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </>
              );
            })}
        </div>
      </div>
      {attachments.length > 0 && (
        <div className="attachment_box">
          <span>
            {attachments[0].path}
            <Button
              color="semantic"
              label={<Icon glyph="trash" weight="light" />}
              onClick={() => setAttachments([])}
            />{' '}
          </span>
        </div>
      )}
      <SendMessageBox
        message={message}
        attachments={attachments}
        onSetMessage={onSetMessage}
        onSetAttachments={onSetAttachments}
        onSendMessage={sendMessage}
        disabled={message || attachments.length !== 0}
      />
    </div>
  );
};

export default InboxMessageChat;
